import { FC, SetStateAction } from 'react';

type Props = {
  isExpanded: boolean;
  setIsExpanded: (value: SetStateAction<boolean>) => void;
  setAccordionOption: (value: React.SetStateAction<string>) => void;
  label: string;
};

const AccordionContent: FC<Props> = ({
  isExpanded,
  label,
  setIsExpanded,
  setAccordionOption,
}) => {
  return (
    <div
      className={`flex justify-between items-center ${
        isExpanded ? 'bg-blue200' : 'bg-blue100'
      } hover:bg-blue200 px-3 lg:px-5 py-3 rounded-md transition-all cursor-pointer`}
      onClick={() => {
        setIsExpanded(!isExpanded);
        setAccordionOption('');
      }}
    >
      <h3 className={`text-blue700 font-icb text-lg lg:text-xl mb-0`}>
        {label}
      </h3>
      <img
        width="20"
        height="20"
        src="/Images/Icons/Arrows/arrow-down-blue700.svg"
        className={`h-5 w-auto transition ease duration-200 ${
          isExpanded ? 'rotate-180' : ''
        }`}
        alt="pil"
        loading="lazy"
      />
    </div>
  );
};

export default AccordionContent;
